import { ref, computed, watch } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d2c27dea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sider-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pl-name"
}, "内购后台", -1));
const _hoisted_3 = {
  class: "menu-name"
};
const _hoisted_4 = {
  class: "menu-name"
};
const _hoisted_5 = ["title"];
const __default__ = {
  name: 'siderIndex'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from '@/store';
import { reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const router = useRouter(),
      route = useRoute(),
      store = useStore();
    const selectedKeys = ref([]),
      openKeys = ref([]);
    const clickItem = obj => {
      !isCollapsed.value && (openKeys.value = obj.keyPath);
      try {
        var _pageKeyValue$value;
        router.push({
          name: obj.key
        });
        reportEvent({
          eventName: 'ui_open',
          properties: {
            ui_name: `${(_pageKeyValue$value = pageKeyValue.value) === null || _pageKeyValue$value === void 0 ? void 0 : _pageKeyValue$value[obj.key]}页面打开`
          }
        });
      } catch (error) {
        message.error('功能还在开发中...敬请期待');
      }
    };
    const pageKeyValue = computed(() => {
      // 根据menu的children返回页面key值
      const obj = {};
      menu.value.forEach(item => {
        if (item.children) {
          item.children.forEach(child => {
            obj[child.menuAdr || ''] = child.menuName || '';
          });
        } else {
          obj[item.menuAdr || ''] = item.menuName || '';
        }
      });
      return obj;
    });
    const menu = computed(() => {
      // 对菜单数据根据priority排序
      const sortedMenu = [...store.menuData].sort((a, b) => {
        var _a$priority, _b$priority;
        // 如果priority不存在，默认为0
        const priorityA = (_a$priority = a.priority) !== null && _a$priority !== void 0 ? _a$priority : 0;
        const priorityB = (_b$priority = b.priority) !== null && _b$priority !== void 0 ? _b$priority : 0;
        return priorityA - priorityB;
      });
      // 对每个菜单项的children进行排序
      sortedMenu.forEach(item => {
        if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          item.children = [...item.children].sort((a, b) => {
            var _a$priority2, _b$priority2;
            const priorityA = (_a$priority2 = a.priority) !== null && _a$priority2 !== void 0 ? _a$priority2 : 0;
            const priorityB = (_b$priority2 = b.priority) !== null && _b$priority2 !== void 0 ? _b$priority2 : 0;
            return priorityA - priorityB;
          });
        }
      });
      return sortedMenu;
    });
    const menuNames = computed(() => {
      // 静态路由名称
      const staticRoutes = ['goodsSettingDetail', 'thirdPartyBillDetail', 'systemNotificationDetail', 'notificationList', 'promotionCodeAdd', 'reconciliationDetail'];
      // 获取一级菜单的路由名称
      const firstLevelRoutes = menu.value.filter(item => item.menuAdr).map(item => item.menuAdr);
      // 获取二级菜单的路由名称
      const secondLevelRoutes = menu.value.filter(item => item.children && Array.isArray(item.children)).flatMap(item => {
        var _item$children;
        return ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.filter(child => child.menuAdr).map(child => child.menuAdr)) || [];
      });
      // 合并所有路由名称
      return [...new Set([...firstLevelRoutes, ...secondLevelRoutes, ...staticRoutes])];
    });
    // 获取默认路由
    const getDefaultRoute = () => {
      var _menu$value, _firstMenuItem$childr;
      const firstMenuItem = (_menu$value = menu.value) === null || _menu$value === void 0 ? void 0 : _menu$value[0];
      if (!firstMenuItem) return null;
      // 如果第一个菜单项有子菜单，返回第一个子菜单的路由
      if ((_firstMenuItem$childr = firstMenuItem.children) !== null && _firstMenuItem$childr !== void 0 && _firstMenuItem$childr.length) {
        return firstMenuItem.children[0].menuAdr;
      }
      // 否则返回第一个菜单项的路由
      return firstMenuItem.menuAdr;
    };
    watch(() => route, newRoute => {
      var _newRoute$meta;
      const isDev = process.env.NODE_ENV === 'development';
      const currentRouteName = newRoute === null || newRoute === void 0 ? void 0 : newRoute.name;
      selectedKeys.value = [currentRouteName];
      // 设置展开的子菜单
      if ((_newRoute$meta = newRoute.meta) !== null && _newRoute$meta !== void 0 && _newRoute$meta.parent) {
        openKeys.value = [newRoute.meta.parent];
      }
      // 仅在非开发环境下进行路由检查
      if (!isDev && currentRouteName) {
        // 检查当前路由是否有效
        if (!menuNames.value.includes(currentRouteName)) {
          const defaultRoute = getDefaultRoute();
          if (defaultRoute) {
            router.push({
              name: defaultRoute
            });
          }
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    const isCollapsed = computed(() => store.isCollapsed);
    return (_ctx, _cache) => {
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_sub_menu = _resolveComponent("a-sub-menu");
      const _component_a_menu = _resolveComponent("a-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_a_menu, {
        class: "pay-menu-box",
        selectedKeys: selectedKeys.value,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = $event => selectedKeys.value = $event),
        openKeys: openKeys.value,
        "onUpdate:openKeys": _cache[1] || (_cache[1] = $event => openKeys.value = $event),
        mode: "inline",
        onClick: clickItem
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), item => {
          var _item$children2;
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.menuAdr
          }, [!((_item$children2 = item.children) !== null && _item$children2 !== void 0 && _item$children2.length) ? (_openBlock(), _createBlock(_component_a_menu_item, {
            key: item.menuAdr
          }, {
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": item.icon,
              "class-name": "menu-icon"
            }, null, 8, ["icon-class"]), _createElementVNode("span", _hoisted_3, _toDisplayString(item['menuName']), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_a_sub_menu, {
            key: String(item.menuAdr),
            class: "pay-sub-menu-box"
          }, {
            title: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": item.icon,
              "class-name": "menu-icon"
            }, null, 8, ["icon-class"]), _createElementVNode("span", _hoisted_4, _toDisplayString(item['menuName']), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, child => {
              return _openBlock(), _createBlock(_component_a_menu_item, {
                key: child.menuAdr,
                class: "subitem-style"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "menu-name sub-menu-name",
                  title: child.menuName
                }, _toDisplayString(child.menuName), 9, _hoisted_5)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1024))], 64);
        }), 128))]),
        _: 1
      }, 8, ["selectedKeys", "openKeys"])]);
    };
  }
});